import { render } from "./ThemeForm.vue?vue&type=template&id=07b0e151&scoped=true"
import script from "./ThemeForm.vue?vue&type=script&lang=js"
export * from "./ThemeForm.vue?vue&type=script&lang=js"

import "./ThemeForm.vue?vue&type=style&index=0&id=07b0e151&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07b0e151"]])

export default __exports__